import React from "react";
import SuccessPage from "./SuccessPage";
import V2RouteShell from "../V2RouteShell";

function SuccessV2(props) {
  return (
    <V2RouteShell>
      <SuccessPage {...props} />
    </V2RouteShell>
  );
}

export default SuccessV2;
